// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max'
import type { ApiResponseVO } from '../../common/types'
import type { UserVO, SuperLoginDto } from '../sys/user'
import { sysUserApi } from '../sys/user'

/** 获取当前的用户：转调 sys/user 服务 GET /users/info */
export async function currentUser(options?: { [key: string]: any }) {
  const res = await sysUserApi.getCurrentUser(options)
  const u = res.data as UserVO | undefined
  const current: API.CurrentUser | undefined = u
    ? {
        name: u.nickname || u.phone || `用户${u.id}`,
        avatar: u.avatar,
        userid: String(u.id),
        email: '',
        address: '',
        phone: u.phone,
        access: u.role,
      }
    : undefined
  return { data: current as API.CurrentUser | undefined }
}

/** 退出登录：清理本地 token 即可 */
export async function outLogin(options?: { [key: string]: any }) {
  localStorage.removeItem('token')
  return Promise.resolve({ success: true, ...(options || {}) })
}

/** 登录接口：转调 sys/user 服务，对接后端 POST /super/auth/login */
export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any },
) {
  const payload: SuperLoginDto = {
    phone: body.username || '',
    password: body.password || '',
  }
  const res: ApiResponseVO<{ token: string }> = await sysUserApi.superLogin(
    payload,
    options,
  )

  if (res.code === 200 && res.data?.token) {
    localStorage.setItem('token', res.data.token)
    const result: API.LoginResult = {
      status: 'ok',
      type: body.type,
      currentAuthority: 'super',
    }
    return result
  }

  const result: API.LoginResult = {
    status: 'error',
    type: body.type,
    currentAuthority: 'guest',
  }
  return result
}

// 下面这些 mock 相关接口暂时保留占位，超管端暂不使用
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  })
}

export async function rule(
  params: {
    current?: number
    pageSize?: number
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  })
}

export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  })
}

export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  })
}

export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  })
}
